import { cn } from '@components/shadcn/utils';
import { SVGProps } from 'react';

export const FarmIcon = ({
  fill = 'currentColor',
  size = 18,
  ...props
}: SVGProps<SVGSVGElement> & { size?: number }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill={fill}
    {...props}
    className={cn('inline-block', props.className)}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.66658 3.27466L11.9999 5.56037V8.66664H10.6666V6.43957L6.66658 4.72528L2.66659 6.43957V8.66664H1.33325V5.56037L6.66658 3.27466Z"
      fill={fill ?? '#DFE2E7'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.33325 6.66658H8.99992V8.66658H7.66658V7.99992H5.66658V8.66658H4.33325V6.66658Z"
      fill={fill ?? '#DFE2E7'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.9999 2.78364V8.66664H10.6666V2.66659H11.3333C10.6666 2.66659 10.6666 2.66593 10.6666 2.66527L10.6666 2.66394L10.6666 2.66121L10.6667 2.65552L10.667 2.64318C10.6673 2.63453 10.6677 2.62504 10.6684 2.61475C10.6698 2.5942 10.6721 2.57034 10.6759 2.54366C10.6835 2.4904 10.6972 2.42493 10.7216 2.3516C10.7713 2.20263 10.8637 2.02662 11.0285 1.86185C11.3643 1.52606 11.8972 1.33325 12.6666 1.33325C13.436 1.33325 13.9689 1.52606 14.3047 1.86185C14.4694 2.02662 14.5619 2.20263 14.6115 2.3516C14.636 2.42493 14.6497 2.4904 14.6573 2.54366C14.6611 2.57034 14.6634 2.5942 14.6648 2.61475C14.6655 2.62504 14.6659 2.63453 14.6662 2.64318L14.6665 2.65552L14.6666 2.66121L14.6666 2.66394L14.6666 2.66527C14.6666 2.66593 14.6666 2.66659 13.9999 2.66659H14.6666V8.66658H13.3333V2.78364C13.3124 2.77093 13.2786 2.75388 13.2266 2.73654C13.1223 2.70179 12.9464 2.66659 12.6666 2.66659C12.3868 2.66659 12.2108 2.70179 12.1066 2.73654C12.0545 2.75388 12.0207 2.77093 11.9999 2.78364Z"
      fill={fill ?? '#DFE2E7'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.6666 10.6666H1.33325V9.33325H14.6666V10.6666Z"
      fill={fill ?? '#DFE2E7'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.6666 12.6666H1.33325V11.3333H14.6666V12.6666Z"
      fill={fill ?? '#DFE2E7'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.6666 14.6666H1.33325V13.3333H14.6666V14.6666Z"
      fill={fill ?? '#DFE2E7'}
    />
  </svg>
);
